import React, { useState } from 'react';
import bridge from '@vkontakte/vk-bridge';
const API_URL = "https://freegptcontact.ru";

function Referrals({ appearance, onBack, referralsCount = 0, userCode, vkUserId, onReferralSuccess, referralCodeUsed = false, onReferralCodeUsed, showToast }) {
  const [inputCode, setInputCode] = useState(() => {
  const hashParams = new URLSearchParams(
    window.location.hash.replace(/^#/, '')
  );

  return (
    hashParams.get('ref')?.trim().toUpperCase() || ''
  );
});
  const [isApplying, setIsApplying] = useState(false);
  


  // ОБНОВЛЕННАЯ ФУНКЦИЯ КОПИРОВАНИЯ (Добавлен параметр type для анимации кнопок)
  const handleCopy = (text, successMessage) => {
  const onSuccess = () => showToast(successMessage);

  if (bridge.supports('VKWebAppCopyText')) {
    bridge.send('VKWebAppCopyText', { text }).then(onSuccess).catch(() => showToast("Не удалось скопировать", "error"));
  } else {
    navigator.clipboard.writeText(text).then(onSuccess).catch(() => showToast("Не удалось скопировать", "error"));
  }
};


  const handleApplyCode = () => {
    if (!inputCode.trim() || isApplying || referralCodeUsed) return;
    setIsApplying(true);
    
    fetch(`${API_URL}/apply_referral`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'vk-sign': window.location.search
      },
      body: JSON.stringify({ user_id: vkUserId, code: inputCode.trim() })
    })
    .then(r => r.json())
    .then(d => {
    if (d.error) {
      if (d.error.includes("уже вводили") && onReferralCodeUsed) onReferralCodeUsed();
      showToast(d.error, "error");
      return;
    }

    showToast(`Код применён. Получено +${d.reward} токенов`);
    setInputCode('');
    if (onReferralCodeUsed) onReferralCodeUsed();
    if (onReferralSuccess) onReferralSuccess(d.reward);
    })
    .catch(() => showToast("Ошибка соединения с сервером", "error"))
    .finally(() => setIsApplying(false));
  };

  let earnedTokens = 0;
  let earnedPhotos = 0;
  for (let i = 1; i <= referralsCount; i++) {
    if (i <= 3) earnedTokens += 2000;
    else if (i <= 13) { earnedTokens += 2500; earnedPhotos += 1; }
    else { earnedTokens += 3000; earnedPhotos += 1; }
  }

  const bgColor = appearance === 'dark' ? '#000000' : '#f2f2f7';
  const cardBg = appearance === 'dark' ? '#1c1c1e' : '#ffffff';
  const textColor = appearance === 'dark' ? '#ffffff' : '#000000';
  const mutedText = appearance === 'dark' ? '#8e8e93' : '#86868b';
  const separatorColor = appearance === 'dark' ? '#38383a' : '#e5e5ea';
  const highlightColor = appearance === 'dark' ? '#a8c7fa' : '#4b37ff';

  const displayCode = userCode || 'ЗАГРУЗКА...';

  const PerkItem = ({ text }) => (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginTop: '8px' }}>
      <div style={{ color: highlightColor, fontSize: '18px', lineHeight: '14px' }}>•</div>
      <div style={{ fontSize: '13px', lineHeight: 1.3, color: textColor }}>{text}</div>
    </div>
  );

  return (
    <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', backgroundColor: bgColor, color: textColor, padding: '32px 20px 90px 20px', boxSizing: 'border-box' }}>
      <style>{`
        .hide-scrollbar::-webkit-scrollbar { display: none; } 
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        .referral-button { transition: filter 120ms ease, opacity 120ms ease; }
        .referral-button:not(:disabled):active { filter: brightness(1.18); opacity: 0.8; }
      `}</style>

      {/* НОВЫЙ БЛОК: ВВОД КОДА */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{ fontSize: '13px', textTransform: 'uppercase', color: mutedText, marginBottom: '8px', fontWeight: 500, letterSpacing: '0.5px', textAlign: 'center' }}>
          {referralCodeUsed ? 'Код приглашения' : 'Есть код от друга?'}
        </div>
        {referralCodeUsed ? (
      <div style={{ padding: '14px', borderRadius: '12px', backgroundColor: cardBg, color: mutedText, textAlign: 'center', fontSize: '15px', fontWeight: 600 }}>
        ✓ Код уже использован
      </div>
    ) : (
      <div style={{ display: 'flex', gap: '8px' }}>
        <input
          type="text"
          placeholder="Ввести код..."
          value={inputCode}
          onChange={e => setInputCode(e.target.value.toUpperCase())}
          style={{ flex: 1, padding: '14px', borderRadius: '12px', border: `1px solid ${separatorColor}`, backgroundColor: cardBg, color: textColor, fontSize: '16px', outline: 'none', WebkitAppearance: 'none' }}
        />
        <button
          className="referral-button"
          onClick={handleApplyCode}
          disabled={isApplying || !inputCode.trim()}
          style={{ padding: '0 20px', borderRadius: '12px', border: 'none', backgroundColor: inputCode.trim() ? highlightColor : separatorColor, color: inputCode.trim() ? (appearance === 'dark' ? '#000' : '#fff') : mutedText, fontSize: '15px', fontWeight: 600, cursor: inputCode.trim() ? 'pointer' : 'default', transition: 'all 0.2s' }}
        >
          ОК
        </button>
      </div>
    )}
      </div>

      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <div style={{ fontSize: '13px', textTransform: 'uppercase', color: mutedText, marginBottom: '8px', fontWeight: 500, letterSpacing: '0.5px' }}>
          Мой код
        </div>
        <div style={{ fontSize: 'clamp(18px, 5.5vw, 28px)', fontWeight: 700, letterSpacing: '1px', color: highlightColor, wordBreak: 'break-all', lineHeight: 1.25 }}>
          {displayCode}
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: cardBg, borderRadius: '16px', padding: '16px 0', marginBottom: '32px', boxShadow: appearance === 'dark' ? 'none' : '0 2px 8px rgba(0,0,0,0.04)' }}>
        <div style={{ textAlign: 'center', flex: 1 }}>
          <div style={{ fontSize: '22px', fontWeight: 600 }}>{referralsCount}</div>
          <div style={{ fontSize: '12px', color: mutedText, marginTop: '4px' }}>Друзей</div>
        </div>
        <div style={{ width: '1px', backgroundColor: separatorColor }}></div>
        <div style={{ textAlign: 'center', flex: 1 }}>
          <div style={{ fontSize: '22px', fontWeight: 600, color: highlightColor }}>+{earnedTokens}</div>
          <div style={{ fontSize: '12px', color: mutedText, marginTop: '4px' }}>Токенов</div>
        </div>
        <div style={{ width: '1px', backgroundColor: separatorColor }}></div>
        <div style={{ textAlign: 'center', flex: 1 }}>
          <div style={{ fontSize: '22px', fontWeight: 600, color: highlightColor }}>+{earnedPhotos}</div>
          <div style={{ fontSize: '12px', color: mutedText, marginTop: '4px' }}>Фото</div>
        </div>
      </div>

      <div style={{ fontSize: '15px', fontWeight: 600, color: mutedText, marginBottom: '12px', paddingLeft: '4px' }}>
        Уровни программы
      </div>
      
      <div className="hide-scrollbar" style={{ display: 'flex', overflowX: 'auto', scrollSnapType: 'x proximity', WebkitOverflowScrolling: 'touch', paddingBottom: '24px', margin: '0 -20px', paddingLeft: '20px', paddingRight: '20px', gap: '12px' }}>
        
        {/* Карточка 1: новИИчок */}
        <div style={{ width: '280px', maxWidth: '85vw', flexShrink: 0, scrollSnapAlign: 'center', backgroundColor: cardBg, borderRadius: '16px', padding: '20px', boxShadow: appearance === 'dark' ? 'none' : '0 2px 8px rgba(0,0,0,0.04)', display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={highlightColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
              <span style={{ fontSize: '18px', fontWeight: 600 }}>новИИчок</span>
            </div>
            <span style={{ fontSize: '14px', color: mutedText, fontWeight: 500 }}>{Math.min(referralsCount, 3)} / 3</span>
          </div>
          <div style={{ width: '100%', height: '4px', backgroundColor: separatorColor, borderRadius: '2px', marginBottom: '16px' }}>
            <div style={{ width: `${Math.min((referralsCount / 3) * 100, 100)}%`, height: '100%', backgroundColor: highlightColor, borderRadius: '2px' }}></div>
          </div>
          <div style={{ fontSize: '14px', lineHeight: 1.4, color: mutedText, flex: 1, display: 'flex', flexDirection: 'column' }}>
            <div style={{ marginBottom: '16px' }}>Ваши друзья получают бонус <span style={{ color: highlightColor, fontWeight: 600 }}>+5 000</span> токенов на старте.</div>
            <div style={{ marginTop: 'auto', paddingTop: '16px', borderTop: `1px solid ${separatorColor}` }}>
              <div style={{ fontSize: '11px', fontWeight: 600, color: mutedText, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Вы получаете</div>
              <PerkItem text="+2 000 токенов к лимиту" />
            </div>
          </div>
        </div>

        {/* Карточка 2: ИИнтеллектуал */}
        <div style={{ width: '280px', maxWidth: '85vw', flexShrink: 0, scrollSnapAlign: 'center', backgroundColor: cardBg, borderRadius: '16px', padding: '20px', boxShadow: appearance === 'dark' ? 'none' : '0 2px 8px rgba(0,0,0,0.04)', display: 'flex', flexDirection: 'column', opacity: referralsCount >= 3 ? 1 : 0.5 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={highlightColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
              <span style={{ fontSize: '18px', fontWeight: 600 }}>ИИнтеллектуал</span>
            </div>
            <span style={{ fontSize: '14px', color: mutedText, fontWeight: 500 }}>{Math.max(0, referralsCount - 3)} / 10</span>
          </div>
          <div style={{ width: '100%', height: '4px', backgroundColor: separatorColor, borderRadius: '2px', marginBottom: '16px' }}>
            <div style={{ width: `${Math.min((Math.max(0, referralsCount - 3) / 10) * 100, 100)}%`, height: '100%', backgroundColor: highlightColor, borderRadius: '2px' }}></div>
          </div>
          <div style={{ fontSize: '14px', lineHeight: 1.4, color: mutedText, flex: 1, display: 'flex', flexDirection: 'column' }}>
            <div style={{ marginBottom: '16px' }}>Стартовый бонус для друзей увеличивается до <span style={{ color: highlightColor, fontWeight: 600 }}>+6 000</span> токенов.</div>
            <div style={{ marginTop: 'auto', paddingTop: '16px', borderTop: `1px solid ${separatorColor}` }}>
              <div style={{ fontSize: '11px', fontWeight: 600, color: mutedText, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Вы получаете</div>
              <PerkItem text="+2 500 токенов к лимиту" />
              <PerkItem text="+1 генерация фото" />
            </div>
          </div>
        </div>

        {/* Карточка 3: НачальнИИк */}
        <div style={{ width: '280px', maxWidth: '85vw', flexShrink: 0, scrollSnapAlign: 'center', backgroundColor: cardBg, borderRadius: '16px', padding: '20px', boxShadow: appearance === 'dark' ? 'none' : '0 2px 8px rgba(0,0,0,0.04)', display: 'flex', flexDirection: 'column', opacity: referralsCount >= 13 ? 1 : 0.5 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={highlightColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 22 8.5 12 22 2 8.5 12 2"></polygon></svg>
              <span style={{ fontSize: '18px', fontWeight: 600 }}>НачальнИИк</span>
            </div>
            <span style={{ fontSize: '14px', color: highlightColor, fontWeight: 600 }}>MAX</span>
          </div>
          <div style={{ width: '100%', height: '4px', backgroundColor: separatorColor, borderRadius: '2px', marginBottom: '16px' }}>
            <div style={{ width: `${referralsCount >= 13 ? 100 : 0}%`, height: '100%', backgroundColor: highlightColor, borderRadius: '2px' }}></div>
          </div>
          <div style={{ fontSize: '14px', lineHeight: 1.4, color: mutedText, flex: 1, display: 'flex', flexDirection: 'column' }}>
            <div style={{ marginBottom: '16px' }}>Высший ранг. Друзья получают максимальные <span style={{ color: highlightColor, fontWeight: 600 }}>+7 000</span> токенов.</div>
            <div style={{ marginTop: 'auto', paddingTop: '16px', borderTop: `1px solid ${separatorColor}` }}>
              <div style={{ fontSize: '11px', fontWeight: 600, color: mutedText, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Вы получаете</div>
              <PerkItem text="+3 000 токенов к лимиту" />
              <PerkItem text="+1 генерация фото" />
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '16px' }}>
        
        {/* ОБНОВЛЕННЫЕ АНИМИРОВАННЫЕ КНОПКИ */}
        <button className="referral-button" onClick={() => handleCopy(String(displayCode), "Реферальный код скопирован")} style={{ width: '100%', padding: '16px', borderRadius: '14px', border: `1px solid ${highlightColor}`, backgroundColor: 'transparent', color: highlightColor, fontSize: '16px', fontWeight: 600, cursor: 'pointer' }}>
        Копировать код
        </button>

        <button className="referral-button" onClick={() => handleCopy(`https://vk.com/app54366580#referrals&ref=${encodeURIComponent(displayCode)}`, "Ссылка скопирована")} style={{ width: '100%', padding: '16px', borderRadius: '14px', border: 'none', backgroundColor: highlightColor, color: appearance === 'dark' ? '#000' : '#fff', fontSize: '16px', fontWeight: 600, cursor: 'pointer' }}>
          Копировать ссылку
        </button>

        <button onClick={onBack} style={{ width: '100%', padding: '16px', borderRadius: '14px', border: 'none', backgroundColor: cardBg, color: textColor, fontSize: '16px', fontWeight: 500, cursor: 'pointer', transition: 'opacity 0.2s' }}>
          Вернуться в чат
        </button>
      </div>
    </div>
  );
}

export default Referrals;